import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import fadeStar from '../../../images/rating.svg'
import fillStar from '../../../images/ratingfill.svg';
import { fetchFeedbackReasons } from '../../../services';
import { showError } from '../../../utils';
import Choice from './Choice';
import { useDispatch, useSelector } from 'react-redux';
import { addFeedback, removeFeedbackByType, resetFeedback } from '../../../actions';
import config from '../../../config';

const OuterContainer = styled.div`
flex: 1 1 45%;
display: flex;
flex-direction: column;
background-color: ${({ selectedStar }) => (selectedStar > 0 ? '#FFF8EB' : '#F0F3F63D')};
border: 1px solid #F0F3F6;
border-radius: 12px;
`;

const HeadContainer = styled.div`
flex: 1 1 30%;
padding: 20px;
border-bottom: 1px solid #F0F3F6;
`;

const HeadText = styled.p`
font-size: 12px;
font-weight: 600;
line-height: 18px;
letter-spacing: 0.25px;
text-align: left;
`;

const StarContainer = styled.div`
flex: 1 1 70%;
padding: 15px;
display: flex;
justify-content: space-between;
`;

const ChoiceContainer = styled.div`
display: flex;
flex-direction: column;
gap: 8px;
background: white;
padding: 15px;
`;

const TextArea = styled.textarea`
resize: none;
display: flex;
min-height: 85px;
gap: 8px;
border-radius: 12px;
border: 1px solid #E3E3E3;
opacity: 0px;
padding: 10px;
align-items: center;
background: #F0F3F63D;
font-size: 12px;
font-weight: 500;
line-height: 18px;
text-align: left;
`;

const Rate = ({ type, feedbackStatus }) => {
  const dispatch = useDispatch();
  const [selectedStar, setSelectedStar] = useState(0);
  const [reasons, setReasons] = useState([]);
  const [selectedChoices, setSelectedChoices] = useState([]);
  const [selectedReasons, setSelectedReasons] = useState([]);
  const [remarks, setRemarks] = useState('');
  const stars = new Array(5).fill(null);

  const { userName, feedbacks } = useSelector((state) => state.feedback);

  useEffect(() => {
    if (feedbackStatus && feedbackStatus.feedBackStatus) {
      const feedback = feedbackStatus.feedBacks.find(item => item.type === type);
      setSelectedStar(feedback.rating);
    }
  }, [feedbackStatus]);

  useEffect(() => {
    if (selectedStar === 0) {
      setSelectedReasons([]);
      dispatch(removeFeedbackByType(type));
    }
    if (selectedStar > 0) {
      fetchFeedbackReasonsForRating();
      const feedback = {
        rating: selectedStar,
        type,
        userName,
        remarks: remarks.length > 0 ? remarks : null,
        platform: 'WEB',
        version: config.version
      };
      dispatch(addFeedback(feedback));
    }
  }, [selectedStar]);

  useEffect(() => {
    if (selectedStar > 0) {
      const feedback = {
        rating: selectedStar,
        type,
        userName,
        remarks: remarks.length > 0 ? remarks : null,
        reasons: selectedReasons.length === 0 ? null : selectedReasons,
        platform: 'WEB',
        version: config.version
      };
      dispatch(addFeedback(feedback));
    }
  }, [selectedReasons]);

  useEffect(() => {
    if (remarks.length > 0) {
      const feedback = {
        rating: selectedStar,
        type,
        userName,
        remarks,
        reasons: selectedReasons.length === 0 ? null : selectedReasons,
        platform: 'WEB',
        version: config.version
      };
      dispatch(addFeedback(feedback));
    }
  }, [remarks]);

  const fetchFeedbackReasonsForRating = async () => {
    try {
      const data = await fetchFeedbackReasons({type, rating: selectedStar});
      if (data.feedbackReasons) {
        const sortedReasons = data.feedbackReasons.sort((a, b) => a.priority - b.priority);
        // const lastReasonId = sortedReasons[sortedReasons.length - 1].reasonId;
        // sortedReasons.push({ reasonId: lastReasonId + 1, reason: 'Other (Please specify)' });
        setReasons(sortedReasons);
      }
    }
    catch (err) {
      showError(err);
    }
  }

  const handleClick = (index) => {
    if (selectedStar === index + 1) {
      setSelectedStar(0); // Deselect all stars if the same star is clicked
    } else {
      setSelectedStar(index + 1); // Select the clicked star
    }
  };

  const handleChoiceClick = (id, reason) => {
    setSelectedChoices(prevSelected =>
      prevSelected.includes(id)
        ? prevSelected.filter(choiceId => choiceId !== id) // Deselect if already selected
        : [...prevSelected, id] // Select if not already selected
    );
    if (reason !== 'Other (Please specify)') {
      setSelectedReasons(prevSelected => 
        prevSelected.includes(reason) 
        ? prevSelected.filter((text) => text !== reason)
        : [...prevSelected, reason]
      );
    }
  };

  if (feedbackStatus && feedbackStatus.feedBackStatus) {
    return (
      <OuterContainer selectedStar={selectedStar}>
         <HeadContainer>
          {
            type === 'app' ? (<HeadText>Rate your experience with Visit App?</HeadText>) : (<HeadText>Rate your experience with doctor?</HeadText>)
          }
        </HeadContainer>
         <StarContainer>
            {stars.map((_, index) => (
                <img
                    key={index}
                    src={index < selectedStar ? fillStar : fadeStar}
                    alt='star'
                    style={{ cursor: 'pointer' }}
                />
            ))}
        </StarContainer>
      </OuterContainer>
    )
  }

  return (
    <OuterContainer selectedStar={selectedStar}>
        <HeadContainer>
          {
            type === 'app' ? (<HeadText>Rate your experience with Visit App?</HeadText>) : (<HeadText>Rate your experience with doctor?</HeadText>)
          }
        </HeadContainer>
        <StarContainer>
            {stars.map((_, index) => (
                <img
                    key={index}
                    src={index < selectedStar ? fillStar : fadeStar}
                    alt='star'
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleClick(index)}
                />
            ))}
        </StarContainer>
        {
            selectedStar > 0 && reasons.length > 0 && (
                <ChoiceContainer>
                    <HeadText>Help us know more about your experience</HeadText>
                    <div style={{maxHeight: '300px', overflow: 'auto', gap: '8px', display: 'flex', flexDirection: 'column'}}>
                        {
                          reasons.map((item) => (
                            <Choice key={item.reasonId} choice={item.reason} isSelected={selectedChoices.includes(item.reasonId)} onClick={() => handleChoiceClick(item.reasonId, item.reason)}/>
                          ))
                        }
                        {
                          (<TextArea placeholder='Anything else you want to elaborate about your experience? (optional)' value={remarks} onChange={(e) => setRemarks(e.target.value)}/>)
                        }
                    </div>
                </ChoiceContainer>
            )
        }
    </OuterContainer>
  )
}

export default Rate